import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";

// ✅ Optional: Catch global errors (VERY useful for debugging)
window.onerror = function (message, source, lineno, colno, error) {
  console.error("GLOBAL ERROR:", {
    message,
    source,
    lineno,
    colno,
    error,
  });
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);